import { createSlice } from "@reduxjs/toolkit";
import { IAgentTasksResponseBody } from "../../models/agent/policiesListing";
import { GetAgentCustomerTasks, GetAgentTasks, DeleteAgentTask } from "./MyTasksAction";

const initialState: IAgentTasksResponseBody = {
  data: [],
  status: "",
  message: "",
};

const AgentTasksSlice = createSlice({
  name: "agentTasks",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(GetAgentTasks.fulfilled, (state, { payload }) => {
      // if (payload.status === "SUCCESS") {
      state.data = payload.data ? payload.data : [];
      // }
    });
    builder.addCase(GetAgentCustomerTasks.fulfilled, (state, { payload }) => {
      // if (payload.status === "SUCCESS") {
      state.data = payload.data ? payload.data : [];
      // }
    });
    builder.addCase(DeleteAgentTask.fulfilled, (state, { payload }) => {
      // Handle successful task deletion
      // The task list will be refreshed by the parent component
      state.status = payload.status;
      state.message = payload.message;
    });
  },
});

export default AgentTasksSlice.reducer;
